
<template>
  <div class="searchTableComponent">
    <input type="text" class="text-search"
           @keyup.enter="search()"
           @input="changeFlag"
           v-show="true"
           v-model="searchText"
           :maxlength="maxLengthValue"          
           placeholder= "Search"/>
           <span class="search-clear-icon clear-button-list-filter"
           :class="{'hidden':hideClearIcon}" 
           @click="clear()"
    ></span> 
    <span class="magnifier-icon magnifier-icon-list-filter"
          @click="search()"
    ></span>
  </div>
</template>
<script>
  import EventBus from '../EventBus.js';
  import {
    FILTER_CLOSE_EVENT,
    REFRESH_TABLE_CONTROLS_SEARCH_EVENT,
    SEARCH_CHANGE_EVENT,
  } from '../js/event.js';

   export default {
    name: 'search-table-component',
    data() {
      return {
        maxLengthValue: 255,
        searchText: '',
        showFlag:false,
        show: false,
      };
    },
    computed: {
      hideClearIcon() {
          if(this.show===false){
              return true;
          }     
        else{
            return false;
        }
      },
      changeFlag(){
        if(this.searchText.length===0){
          return true;
        }else{
          return false;
        }
      }
    },
    mounted() {
      if(this.$session.exists("search-data")){
          this.searchText= this.$session.get("search-data");  
          this.show=true;
          this.showFlag=true;
       }else{
          this.searchText;
       }
       
      EventBus.$on(REFRESH_TABLE_CONTROLS_SEARCH_EVENT, () => this.clear());
    },
    beforeDestroy() {
      EventBus.$off(REFRESH_TABLE_CONTROLS_SEARCH_EVENT);
    },
    methods: { 
      search() {
        if (this.searchText.length > 0) {
          this.$emit(SEARCH_CHANGE_EVENT, this.searchText);
          EventBus.$emit(FILTER_CLOSE_EVENT);
          this.$session.set("search-data", this.searchText);
        }
      },
      clear() {
        this.searchText = '';
        if(this.searchText===''){
          this.show=false;
        }
      },
      
    },
  };
</script>

<style lang="scss" scoped>
  @import "../styles/hpConstant.scss";
  @import "../styles/hpMixin.scss";

  .searchTableComponent {
    position: relative;
    display: flex;
   
    height: 50px;
    border-left: $hpLightBlue 2px solid;
    border-right: $hpLightBlue 2px solid;
    border-top: $hpLightBlue 2px solid;

    input[type=text]::-ms-clear {
      display: none
    }

    .text-search {
      @include boxSizingBorderBox;
      box-sizing: border-box;
      color: $hpBlack;
      width: 60%;
      height: 30px;
      margin: 10px 1%;
      padding: 0 10px;
      background: $hpWhite;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      outline: none;
      border: $hpWhite 1px solid;
    }

    .text-search::placeholder {
      color: $hpHighGray;
      font-family: "hpSimplifiedText", Arial, Helvetica, sans-serif;
      font-size: 14px;
    }
    .text-search:-ms-input-placeholder {
      color: $hpHighGray;
    }

    .search-clear-icon {
      background-image: url("../assets/images/icons/search_close.png");
      
    }

    .search-clear-icon:hover, .search-clear-icon:active {
      background-image: url('../assets/images/icons/search_delete_over_pre.png');
      background-color: $hpLightBlue;
    }

    .clear-button-list-filter {
      position: absolute;
      text-align: right;
      top: 0;
      right: 18px;
      height: 50px;
      width: 36px;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
    }

    .magnifier-icon {
      background-image: url('../assets/images/icons/search_light_blue_30.png');
    }

    .magnifier-icon-list-filter {
      height: 48px;
      width: 36px;
      position: absolute;
      text-align: right;
      top: 0;
      right: 0;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
    }

    .hidden {
      display: none
    }
  }
</style>